import * as React from 'react'

import { useCachedLoaderData } from '../../hooks/useCachedLoaderData'
import { StickyShadow } from '../options/components/StickyShadow'
import { FilingsTable } from './components/FilingsTable'
import { FormCategoryFilter } from './components/FormCategoryFilter'
import { ParsedLatestFilingsData, SerializedLatestFilingsData } from './constants/types'
import { useTableFilter } from './hooks/useTableFilter'
import { parseSerializedLatestFilingsData } from './utils'

export default function LatestFilings() {
  const { data } = useCachedLoaderData<SerializedLatestFilingsData | null>()
  const parsedData = React.useMemo<ParsedLatestFilingsData | null>(() => {
    if (!data) return null
    return parseSerializedLatestFilingsData(data)
  }, [data])

  // Remove min-height from react root element which is set on BE because of CLS
  React.useEffect(() => {
    document.getElementById('root')?.style.removeProperty('min-height')
  }, [])

  const { currentCategory, setCategory, filterItems, data: tableData } = useTableFilter({ data: parsedData })
  if (!parsedData || parsedData.items.length === 0) {
    return (
      <div className="fv-container flex h-60 items-center justify-center text-muted">
        Latest SEC Filings are not available for this stock.
      </div>
    )
  }

  return (
    <div className="font-sans">
      <div className="sticky z-10 h-11 bg-primary shadow-md sticky-22"></div>
      <div className="sticky z-30 -mt-11 bg-primary py-2 sticky-22">
        <div className="fv-container flex items-center justify-between space-x-1">
          <div className="w-full text-right text-2xs text-muted-2">Form category</div>
          <div className="shrink-0">
            <FormCategoryFilter
              currentCategory={currentCategory}
              setCurrentCategory={setCategory}
              items={filterItems}
            />
          </div>
        </div>
      </div>
      <div>
        <StickyShadow className="z-10 h-5.5 bg-primary sticky-33" />
        <div className="fv-container relative -mt-5.5">
          <div className="pointer-events-none sticky z-40 -mb-5.5 h-5.5 sticky-33">
            <h2 className="pointer-events-auto absolute -top-11 my-0 pt-2.5 text-base text-muted font-bold">
              Latest SEC Filings
            </h2>
          </div>
          <FilingsTable data={tableData!} isHeaderSticky headerClass="sticky-33 z-10" />
        </div>
      </div>
    </div>
  )
}
